import { render, staticRenderFns } from "./customerRecord.vue?vue&type=template&id=35bdc826&scoped=true"
import script from "./customerRecord.vue?vue&type=script&lang=js"
export * from "./customerRecord.vue?vue&type=script&lang=js"
import style0 from "./customerRecord.vue?vue&type=style&index=0&id=35bdc826&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bdc826",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35bdc826')) {
      api.createRecord('35bdc826', component.options)
    } else {
      api.reload('35bdc826', component.options)
    }
    module.hot.accept("./customerRecord.vue?vue&type=template&id=35bdc826&scoped=true", function () {
      api.rerender('35bdc826', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/run/customerRecord.vue"
export default component.exports